import React from 'react'
import { SubEntityComponent } from '../SubEntityComponent';

export class OptionsSubEntityComponent extends SubEntityComponent {
  constructor(props) {
    super(props)
  }
  renderAboveTable() {
    return (
      this.state.entityItem.title
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/components/quizcreator/OptionsSubEntityComponent.js